/** @jsx h */
import { defineComponent, h, ref, onMounted, onUnmounted } from "vue";
import { useRoute, useRouter, RouterView } from "vue-router";

import { KernelConnection, BuffersProvider } from "@app/vue/providers/index";
import { fetchSession, bc, connectToMaster } from "../../../utils/boot";

import { BootedLayout, UnbootedLayout } from "@app/vue/components/index";
import type { ILoggedinSession, IUserSession } from "@gratico/kernel";

export const LayoutInner = defineComponent({
  name: "LayoutInner",
  setup() {
    const session = ref<IUserSession | undefined>(undefined);
    const kernelConnection = ref<KernelConnection | undefined>(undefined);
    const router = useRouter();

    onMounted(() => {
      if (kernelConnection.value || session.value) return;

      bc.postMessage({ message: "fetching session" });

      const { host } = window.location;
      console.log("mounted");
      fetchSession(host)
        .then(async (res) => {
          console.log(res);
          if (!res || !res.loggedIn) {
            const redirectUrl = `/~/api/v1/auth/session/initiate?href=${encodeURIComponent(
              window.location.pathname
            )}&host=${encodeURIComponent(window.location.host)}`;
            window.location.href = redirectUrl;
          } else {
            session.value = res;
            console.log("session res", res);
            try {
              console.time("connectToMaster");
              const connection = await connectToMaster(router, {
                session: res,
              });
              console.timeEnd("connectToMaster");
              console.log("connection", connection);

              kernelConnection.value = {
                kernel: connection.kernel,
                master: connection.master,
                viewport: connection.viewport,
              };
            } catch (err: any) {
              console.error(err);
              alert(`Error occurred: ${err?.message}`);
            }
          }
        })
        .catch((err) => {
          console.error(err);
          const reload = confirm(
            `Something went wrong while fetching your session! ${err.message}! Reload?`
          );
          if (reload) window.location.reload();
        });
    });

    onUnmounted(() => {
      if (kernelConnection.value) {
        // Cleanup logic if needed
      }
    });

    return () =>
      kernelConnection.value ? (
        <BootedLayout
          connection={kernelConnection.value}
          session={session.value as ILoggedinSession}
        />
      ) : (
        <UnbootedLayout />
      );
  },
});

export const LayoutPage = defineComponent({
  name: "Layout",
  setup() {
    return () => <LayoutInner />;
  },
});
